/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getManyBaseMgmtShippingLabelControllerShippingLabel } from '../fn/shipping-label/get-many-base-mgmt-shipping-label-controller-shipping-label';
import { GetManyBaseMgmtShippingLabelControllerShippingLabel$Params } from '../fn/shipping-label/get-many-base-mgmt-shipping-label-controller-shipping-label';
import { GetManyShippingLabelResponseDto } from '../models/get-many-shipping-label-response-dto';
import { getOneBaseMgmtShippingLabelControllerShippingLabel } from '../fn/shipping-label/get-one-base-mgmt-shipping-label-controller-shipping-label';
import { GetOneBaseMgmtShippingLabelControllerShippingLabel$Params } from '../fn/shipping-label/get-one-base-mgmt-shipping-label-controller-shipping-label';
import { mgmtShippingLabelControllerGetLabelFile } from '../fn/shipping-label/mgmt-shipping-label-controller-get-label-file';
import { MgmtShippingLabelControllerGetLabelFile$Params } from '../fn/shipping-label/mgmt-shipping-label-controller-get-label-file';
import { ShippingLabel } from '../models/shipping-label';

@Injectable({ providedIn: 'root' })
export class ShippingLabelApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mgmtShippingLabelControllerGetLabelFile()` */
  static readonly MgmtShippingLabelControllerGetLabelFilePath = '/api/mgmt/shipping-label/{id}/label-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtShippingLabelControllerGetLabelFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShippingLabelControllerGetLabelFile$Response(params: MgmtShippingLabelControllerGetLabelFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = mgmtShippingLabelControllerGetLabelFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtShippingLabelControllerGetLabelFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtShippingLabelControllerGetLabelFile(params: MgmtShippingLabelControllerGetLabelFile$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.mgmtShippingLabelControllerGetLabelFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtShippingLabelControllerShippingLabel()` */
  static readonly GetOneBaseMgmtShippingLabelControllerShippingLabelPath = '/api/mgmt/shipping-label/{id}';

  /**
   * Retrieve a single ShippingLabel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtShippingLabelControllerShippingLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShippingLabelControllerShippingLabel$Response(params: GetOneBaseMgmtShippingLabelControllerShippingLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<ShippingLabel>> {
    const obs = getOneBaseMgmtShippingLabelControllerShippingLabel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single ShippingLabel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtShippingLabelControllerShippingLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShippingLabelControllerShippingLabel(params: GetOneBaseMgmtShippingLabelControllerShippingLabel$Params, context?: HttpContext): Observable<ShippingLabel> {
    const resp = this.getOneBaseMgmtShippingLabelControllerShippingLabel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShippingLabel>): ShippingLabel => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtShippingLabelControllerShippingLabel()` */
  static readonly GetManyBaseMgmtShippingLabelControllerShippingLabelPath = '/api/mgmt/shipping-label';

  /**
   * Retrieve multiple ShippingLabels.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtShippingLabelControllerShippingLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShippingLabelControllerShippingLabel$Response(params?: GetManyBaseMgmtShippingLabelControllerShippingLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShippingLabelResponseDto>> {
    const obs = getManyBaseMgmtShippingLabelControllerShippingLabel(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple ShippingLabels.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtShippingLabelControllerShippingLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShippingLabelControllerShippingLabel(params?: GetManyBaseMgmtShippingLabelControllerShippingLabel$Params, context?: HttpContext): Observable<GetManyShippingLabelResponseDto> {
    const resp = this.getManyBaseMgmtShippingLabelControllerShippingLabel$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShippingLabelResponseDto>): GetManyShippingLabelResponseDto => r.body)
    );
  }

}
